import {
  SET_WEB_SOCKET_CHANEL_REQUEST,
  SET_WEB_SOCKET_CHANEL_SUCCESS,
} from "./constant";

export const SetWebSocketChanel = (chanel) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SET_WEB_SOCKET_CHANEL_REQUEST,
    });

    let obj = { chanel: chanel };
    dispatch({
      type: SET_WEB_SOCKET_CHANEL_SUCCESS,
      payload: obj,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    console.log("error basic message", message);
  }
};
